import { DELAY } from 'src/app/core/utils/constants';
import { PETICIONES } from './../utils/constants';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Parameters } from '../../core/entities/parameters.model';
import { delay } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class ParametersService {
    readonly BASE: any = PETICIONES.parameters;

    constructor(private http: HttpClient) { }

    /**
   * @description
   * Obtiene todos los parameters
   */
  public findAll(): Observable<any> {
    return this.http.get(this.BASE.findAll).pipe(delay(DELAY));
  }

  /**
   * @description
   * Obtiene un parameters por su id
   */
  public findById(id: number): Observable<any> {
    let idparameters: string = (id !== undefined && id !== null ? id + "" : "");
    return this.http.get(this.BASE.findById + "/" + idparameters).pipe(delay(DELAY));
  }

  /**
   * @description
   * Obtiene un parameters por su id
   */
  public findByCode(code: string): Observable<any> {
    let codeparameters: string = (code !== undefined && code !== null ? code + "" : "");
    return this.http.get(this.BASE.findByCode + "/" + codeparameters).pipe(delay(DELAY));
  }

  /**
   * @description
   * Guarda un parameters en la base de datos
   */
  public postParameter(parameters: Parameters): Observable<any> {
    const json = JSON.stringify(parameters);
    const headers = new HttpHeaders().set('Content-Type', 'application/json;charset=UTF-8');
    return this.http.post(this.BASE.postParameters, json, {headers: headers}).pipe(delay(DELAY));
  }

  /**
   * @description
   * Borra un parameters en la base de datos
   */
  public deleteParameter(parameters: Parameters): Observable<any> {
    let idparameters: string = (parameters.id !== undefined && parameters.id !== null ? parameters.id + "" : "");
    return this.http.get(this.BASE.deleteParameters + "/" + idparameters).pipe(delay(DELAY));
  }

}